import { render, staticRenderFns } from "./SmartAntsBar.vue?vue&type=template&id=35311038&scoped=true"
import script from "./SmartAntsBar.vue?vue&type=script&lang=js"
export * from "./SmartAntsBar.vue?vue&type=script&lang=js"
import style0 from "./SmartAntsBar.vue?vue&type=style&index=0&id=35311038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35311038",
  null
  
)

export default component.exports